import React from 'react';

export default class LoginImageSlider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            curImageIndex: 0,
            imagesList: ["/assets/img/slider1.png", "/assets/img/slider2.png", "/assets/img/slider3.png"],
            img1Active: "active",
            img2Active: "",
            img3Active: "",
        }
    }

    componentDidMount() {

    }

    moveToPreviousImage() {
        const curImageIndex = this.state.curImageIndex;

        if (curImageIndex - 1 == 1) {
            this.setState({
                img1Active: "",
                img2Active: "active",
                img3Active: "",
                curImageIndex: curImageIndex - 1,
            })
        } else if (curImageIndex - 1 == 0) {
            this.setState({
                img1Active: "active",
                img2Active: "",
                img3Active: "",
                curImageIndex: curImageIndex - 1,
            })
        }
    }

    moveToNextImage() {
        const curImageIndex = this.state.curImageIndex;

        if (curImageIndex + 1 == 1) {
            this.setState({
                img1Active: "",
                img2Active: "active",
                img3Active: "",
                curImageIndex: curImageIndex + 1,
            })
        } else if (curImageIndex + 1 == 2) {
            this.setState({
                img1Active: "",
                img2Active: "",
                img3Active: "active",
                curImageIndex: curImageIndex + 1,
            })
        }
    }

    setImg1Active(imgIndex) {
        this.setState({
            img1Active: "active",
            img2Active: "",
            img3Active: "",
            curImageIndex: imgIndex
        })
    }

    setImg2Active(imgIndex) {
        this.setState({
            img1Active: "",
            img2Active: "active",
            img3Active: "",
            curImageIndex: imgIndex
        })
    }

    setImg3Active(imgIndex) {
        this.setState({
            img1Active: "",
            img2Active: "",
            img3Active: "active",
            curImageIndex: imgIndex
        })
    }

    render() {
        const curImageIndex = this.state.curImageIndex;
        const imagesList = this.state.imagesList;
        var descriptions = ["Sign leases electronically, collect security deposits, and request lease renewals in just one click.", "Collect automated rent, manage lease terms, and offer renters' insurance to tenants through one simple tenant portal.", "Track trending net income and pull property reports from real-time data."];
        var descriptions = descriptions.map((description) =>  <p class="slider-text">{description}</p>);

        return (
            <div class="login-image-slider-container">
                <div class="">
                    <div class="col-md-12 col-no-pad">
                        {curImageIndex != 0 ? (
                            <i class="fa fas fa-chevron-left login-image-slider-arrows" onClick={this.moveToPreviousImage.bind(this)}/>
                        ) : (
                            <i class="fa fas fa-chevron-left login-image-slider-arrows" style={{visibility: "hidden"}}/>
                        )}
                        <img style={{
                            objectFit: "contain",
                            width: "calc( 100% - 162.866px)",
                            height: "100%"
                        }} src={imagesList[curImageIndex]}/>
                        {curImageIndex != 2 ? (
                            <i class="fa fas fa-chevron-right login-image-slider-arrows" onClick={this.moveToNextImage.bind(this)}/>
                        ) : (
                            <i class="fa fas fa-chevron-right login-image-slider-arrows" style={{visibility: "hidden"}}/>
                        )}
                    </div>
                </div>
                <div class="row login-image-slider-text-row">
                    <div class="col-md-12">{descriptions[curImageIndex]}</div>
                </div>
                <div class="">
                    <i class={"fa fas fa-circle login-image-slider-circle-choose " + this.state.img1Active} onClick={this.setImg1Active.bind(this, 0)}/>
                    <i class={"fa fas fa-circle login-image-slider-circle-choose " + this.state.img2Active} onClick={this.setImg2Active.bind(this, 1)}/>
                    <i class={"fa fas fa-circle login-image-slider-circle-choose " + this.state.img3Active} onClick={this.setImg3Active.bind(this, 2)}/>
                </div>
            </div>
        )
    }
};




// WEBPACK FOOTER //
// app/components/Login/LoginImageSlider.jsx